import { Autocomplete, Stack, TextField } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { useHistory } from 'react-router';
import { makeStyles } from 'tss-react/mui';
import useDebounce from '../../hooks/useDebounce';
import { helpRoutes } from '../../routes';
import { useSearchArticles } from '../../sic-lib/api/hooks/useHelp';
import { Article } from '../../sic-lib/types/Article';

export default function HelpSearch() {
    const { classes } = useStyles();
    const history = useHistory();

    const [searchValue, setSearchValue] = React.useState<string>('');

    const debouncedSearchValue = useDebounce(searchValue, 500);

    const { data: searchData, isLoading: isSearchLoading } =
        useSearchArticles(debouncedSearchValue);

    const search = React.useMemo(() => {
        if (searchValue === '') return [];
        return searchData || [];
    }, [searchData, searchValue]);

    const handleChange = (event: React.SyntheticEvent, value: string) => {
        setSearchValue(value);
    };

    const handleSelect = (event: React.SyntheticEvent, value: string | Article | null) => {
        if (value) {
            history.push(helpRoutes.setArticle((value as Article).articleId));
        }
    };

    return (
        <Stack className={classes.root}>
            <Autocomplete
                disablePortal
                id="help-search"
                options={search}
                getOptionLabel={option => option.title}
                renderInput={params => <TextField {...params} label="Search" />}
                loading={isSearchLoading}
                loadingText="Searching..."
                noOptionsText="No articles found."
                onChange={handleSelect}
                onInputChange={handleChange}
                componentsProps={{ paper: { elevation: 4 } }}
            />
        </Stack>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        padding: theme.spacing(1),
    },
}));
